module.exports = __webpack_public_path__ + "static/media/sf-test-16.45e85241.mp3";